import { render, staticRenderFns } from "./NoticiasMercadoAoVivo.vue?vue&type=template&id=74b3cea6&"
import script from "./NoticiasMercadoAoVivo.vue?vue&type=script&lang=js&"
export * from "./NoticiasMercadoAoVivo.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasMercadoAoVivo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports